























import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class AgenciesReportExportPane extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly index!: number;
  @Prop({ default: false }) readonly loading!: boolean;

  goForward() {
    this.$emit("forward");
  }
}
